var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.mediaGalleryContainer},[_c('Carousel',{staticClass:"mb-2",attrs:{"active-index":_vm.data.activeIndex,"options":_vm.sliderOptions,"images":_vm.images,"hide-image-at-index":_vm.data.hideImageAtIndex},on:{"toggle":_vm.openOverlay,"goAction":_vm.go}}),_vm._v(" "),_c('Thumbnails',{directives:[{name:"show",rawName:"v-show",value:(_vm.images.length > 1),expression:"images.length > 1"}],staticClass:"thumbnails relative",attrs:{"active-index":_vm.data.activeIndex,"images":_vm.images,"hide-image-at-index":_vm.data.hideImageAtIndex,"options":{
      type: 'slider',
      autoplay: false,
      rewind: false,
      perView: 6.4,
      gap: 10,
      dragThreshold: 0,
      bound: true,
      breakpoints: {
        380: { perView: 4.1 },
        560: { perView: 4.4 },
        598: { perView: 6.4 },
        800: { perView: 3.6 },
        920: { perView: 4.2 },
        1023: { perView: 5.2 },
        1920: { perView: 6.4 },
      }
    }},on:{"goAction":_vm.go}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }